<script lang="ts">
	import GoogleTagManager from './_GoogleTagManager.svelte';
	import Qualtrics from './_Qualtrics.svelte';
	import TouchIcons from './_TouchIcons.svelte';
	import { production } from '$lib/const';

	export let gtmId: string | null;
	export let qualtricsContainerId: string | null;
	export let metaDescription: string | null;
</script>

<svelte:head>
	{#if metaDescription}
		<meta name="description" content={metaDescription} />
	{/if}

	{#if !production}
		<meta name="robots" content="noindex,nofollow" />
	{/if}
</svelte:head>

<TouchIcons />

{#if gtmId}
	<GoogleTagManager id={gtmId} />
{/if}

{#if qualtricsContainerId}
	<Qualtrics id={qualtricsContainerId} />
{/if}
